import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeEvery } from 'redux-saga/effects';

import PlaceLocalization from '../../../models/interfaces/PlaceLocalization';
import { waitBeforeFetch } from '../../../utils/FetchState';
import {
  fetchPlaceLocalization,
  FetchPlaceLocalizationPayload,
  placeLocalizationFetched,
  placeLocalizationFetchFailed,
} from '../../actions/setting/fetchPlaceLocalization';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* fetchPlaceLocalizationSaga({ payload }: Action<FetchPlaceLocalizationPayload>) {
  const timestamp = moment();
  const token = yield getAuthenticationToken();
  const { placeUuid, fetchState } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getPlaceLocalization, token, { placeUuid });
  const { placeLocalization, error } = response;
  if (!error) {
    const responsePayload = {
      placeLocalization: placeLocalization as PlaceLocalization,
      timestamp,
    };
    const responseAction = placeLocalizationFetched(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = placeLocalizationFetchFailed({ placeUuid, timestamp });
    yield put(responseAction);
  }
}

export default function* watchFectPlaceLocalizationSaga() {
  yield takeEvery(fetchPlaceLocalization, fetchPlaceLocalizationSaga);
}
